export function SpaceMenuBottom() {
  

  return (
    <div style={{ height: "calc(50px + 72px)" }}></div>
  );
}

export default SpaceMenuBottom;